import React from 'react';
import ContactForm from './ContactForm';

export default function ContactSection() {
  return (
    <section className="relative isolate py-20 px-6 bg-black">
      <div className="mx-auto max-w-6xl grid lg:grid-cols-2 gap-12">
        {/* Texto Izquierda */}
        <div className="text-white text-left">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 ring-1 ring-white/10 text-neutral-200 text-sm mb-6">
            <img src="/icons/message.svg" alt="Contáctanos" className="w-4 h-4" />
            <span>Contáctanos</span>
          </div>

          {/* Título grande */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-10">
            ¿Listo para llevar tu
            <br className="hidden sm:block" />
            empresa al siguiente
            <br className="hidden sm:block" />
            nivel?
          </h2>

          {/* Icon pills */}
          <div className="flex items-center gap-4 mb-8">
            <div className="h-11 w-11 rounded-xl bg-white/5 ring-1 ring-white/10 grid place-items-center">
              <img src="/icons/phone.svg" alt="Teléfono" className="w-5 h-5" />
            </div>
          </div>

          {/* Teléfonos */}
          <div className="space-y-2 mb-10">
            <p className="text-neutral-200 font-medium">Teléfono</p>
            <p className="text-neutral-300">Quito: 02 476 7750</p>
            <p className="text-neutral-300">Guayaquil: 098 559 0298</p>
            <p className="text-neutral-300">Cuenca: 099 682 1773</p>
            <p className="text-neutral-300">Whatsapp corporativo: 099 588 6995</p>
          </div>

          {/* Email */}
          <div className="space-y-3 mb-10">
            <div className="h-11 w-11 rounded-xl bg-white/5 ring-1 ring-white/10 grid place-items-center">
              <img src="/icons/email.svg" alt="Email" className="w-5 h-5" />
            </div>
            <div>
              <p className="text-neutral-200 font-medium">Email</p>
              <p className="text-neutral-300">compras@lexis.com.ec</p>
            </div>
          </div>

          {/* Horario */}
          <div className="space-y-3">
            <div className="h-11 w-11 rounded-xl bg-white/5 ring-1 ring-white/10 grid place-items-center">
              <img src="/icons/clock.svg" alt="Horario de atención" className="w-5 h-5" />
            </div>
            <div>
              <p className="text-neutral-200 font-medium">Horario de atención</p>
              <p className="text-neutral-300">8:30am — 6:00pm</p>
            </div>
          </div>
        </div>

        {/* Formulario Derecha */}
        <ContactForm />
      </div>
    </section>
  );
}
